import axios from "axios";
import { auth } from "@Firebase/firebase";

export const getAppVersion = (app: "dealer" | "lender" | "bb") => async () => {
  const token = await auth.currentUser?.getIdToken();

  const response = await axios.get(
    `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/app-version/`,
    {
      params: { app },
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data.result as { version: string; force: boolean };
};
